var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.54102,
    y: 1.74805,
    width: 41.2321,
    height: 36.0781,
    rx: 9.24509,
    stroke: "white",
    strokeWidth: 1.84902
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2629 1.74805L17.2629 37.8261M2.05859 8.70596H17.5206M2.05859 19.014H17.5206M2.05859 29.322H17.5206M27.3132 19.014L42.7753 19.014M27.3132 29.322L42.7753 29.322M27.8287 37.8261C27.8287 37.8261 27.8286 36.5262 27.8287 22.4872C27.8288 8.44826 27.8288 8.44826 42.7753 8.44826",
    stroke: "white",
    strokeWidth: 1.84902
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.915e237a9f37085d67a485249b9e05c1.svg";
export { ForwardRef as ReactComponent };